import React, {Component} from 'react';
import { BrowserRouter, Switch, Link, Route } from 'react-router-dom'; 
 
import axios from 'axios'; 
import {api_base_url, base_url} from '../common/Constants';

 
class ShopContent extends React.Component{

    constructor(props){
        super(props);

        
        this.state = {
            products : [],
            loading : 1 
        }
    }
 
    componentDidMount()
    {
        var data = { id : this.props.slug} 
            axios.post(api_base_url+"category_products", data).then(response=>{
                this.setState({products:response.data}); 
                     
                     this.setState({loading:0})
 
            }); 


    }
    componentDidUpdate(prevProps)
    {
        var data = { id : this.props.slug}
        if (this.props.slug !== prevProps.slug)
        {
            axios.post(api_base_url+"category_products", data).then(response=>{
                this.setState({products:response.data}); 
                this.setState({loading:0});
            });
        }
    }


    render()
    { 
        var categories = JSON.parse(localStorage.getItem("categories"));
        if (this.state.loading == 1) {
            return <div>Loading...</div>;
          }
    return (
        
        <div class="ul-inner-page-container">
            <div class="ul-inner-products-wrapper">
                <div class="row ul-bs-row flex-column-reverse flex-md-row">
                     
                    <div class="col-lg-3 col-md-4">
                        <div class="ul-products-sidebar">
                             
                            <div class="ul-products-sidebar-widget ul-products-search">
                                <form action="#" class="ul-products-search-form">
                                    <input type="text" name="product-search" id="ul-products-search-field" placeholder="Search Items" />
                                    <button><i class="flaticon-search-interface-symbol"></i></button>
                                </form>
                            </div>

                            {/****
                            <div class="ul-products-sidebar-widget ul-products-price-filter">
                                <h3 class="ul-products-sidebar-widget-title">Filter by price</h3>
                                <form action="#" class="ul-products-price-filter-form">
                                    <div id="ul-products-price-filter-slider" data-price='1000'></div>
                                    <span class="filtered-price">$19 - $69</span>
                                </form>
                            </div>
 */} 
                             
                            <div class="ul-products-sidebar-widget ul-products-categories">
                                <h3 class="ul-products-sidebar-widget-title">Categories</h3>

                                <div class="ul-products-categories-link">
                                    {categories.map((item,key)=>( 
                                        <div>
                                            <Link to={base_url+"category/"+item.slug} class={item.parent_id > 0 ? "dblock sub_cat": "dnone"}><span><i class="flaticon-arrow-point-to-right"></i> {item.name} </span></Link>
                                            <Link to={base_url+"category/"+item.slug} class={item.parent_id > 0 ? "dnone": "dblock par_cat"}><span><i class="flaticon-arrow-point-to-right"></i> {item.name} </span></Link>
                                    </div>
                                    ))}
                                     
                                </div>
                            </div>


                         
                        </div>
                    </div>

                     
                    <div class="col-lg-9 col-md-8">
                        <div class="row ul-bs-row row-cols-lg-3 row-cols-2 row-cols-xxs-1">
                            
                            {this.state.products.map((item,key)=>(
                            <div class="col">
                                <div class="ul-product">
                                 

                                    <div class="ul-product-img">
                                         <img src={item.image} alt={item.title} />

                                         {/**** <div class="ul-product-actions">
                                                    <button><i class="flaticon-shopping-bag"></i></button>
                                                    <Link  to="#"><i class="flaticon-hide"></i></Link>
                                                    <button><i class="flaticon-heart"></i></button>
                                                </div> **/ }

                                                   <span class={item.discount > 0 ? "ul-product-discount-tag" : "ul-product-discount-tag dnone"}>{item.discount}% Off</span>   
                                                </div>

                                    <div class="ul-product-txt">
                                        <h4 class="ul-product-title"><Link  to={base_url+"products/"+item.slug}>{item.title}</Link></h4>
                           
                                    </div>
         <div class="ul-product-heading">
                                              
                                 <span class="ul-product-price">{item.price} {item.old_price != item.price && (<label>{item.old_price}</label>  )}</span>
                                            
                                   <Link  to={base_url+"products/"+item.slug}  class={item.quantity > 0 ? " add-button" : "dnone"}>Buy Now</Link>
                                                                            <label class={item.quantity > 0 ? " dnone" : "ostock"}>Out Of Stock</label>
                                                                           </div>
                                </div>
                            </div>
                            ))}
 
                        </div>
   
                       {/** <div class="ul-pagination">
                            <ul>
                                <li><a href="#"><i class="flaticon-left-arrow"></i></a></li>
                                <li class="pages">
                                    <a href="#" class="active">01</a>
                                    <a href="#">02</a>
                                    <a href="#">03</a>
                                    <a href="#">04</a>
                                    <a href="#">05</a>
                                </li>
                                <li><a href="#"><i class="flaticon-arrow-point-to-right"></i></a></li>
                            </ul>
                        </div> */}
                    </div>
                </div>
            </div>
        </div>
    );
}

}

export default ShopContent;